import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLang } from "../i18n";
import { PageHero } from "../components/PageHero";
import { Seo } from "../components/Seo";
import { FinalCTA } from "../components/FinalCTA";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import NotFound from "./NotFound";

const NewsDetail = () => {
  const { lang, t, p } = useLang();
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/public/posts/${slug}`).then((r) => setPost(r.data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <NotFound />;
  if (!post) return <div className="min-h-screen bg-[#08090A]" />;

  const title = lang === "fr" ? post.title_fr : post.title_en;
  const body = lang === "fr" ? post.body_fr : post.body_en;
  const articleLd = {
    "@context": "https://schema.org", "@type": "Article", headline: title,
    author: { "@type": "Organization", name: "Bula Telecoms SA" },
    datePublished: post.created_at,
  };

  return (
    <div data-testid="news-detail-page">
      <Seo title={title} description={lang === "fr" ? post.summary_fr : post.summary_en} path={`actualites/${slug}`} type="article" jsonLd={articleLd} />
      <PageHero eyebrow={post.category.toUpperCase()} title={title}
        crumbs={[{ label: t.nav.news, to: p("actualites") }, { label: title }]} />
      <section className="bg-[#F5F5F3]">
        <article className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
          {(lang === "fr" ? post.summary_fr : post.summary_en) && (
            <p className="text-lg font-bold text-[#101214]/80 leading-relaxed">{lang === "fr" ? post.summary_fr : post.summary_en}</p>
          )}
          <div className="mt-8 space-y-5">
            {(body || "").split("\n").filter(Boolean).map((para, i) => (
              <p key={i} className="text-base text-[#101214]/70 leading-relaxed">{para}</p>
            ))}
          </div>
          <Link to={p("actualites")} data-testid="news-back-link"
            className="mt-12 inline-flex items-center gap-2 text-sm font-black text-[#FF6600]">
            <ArrowLeft size={15} /> {t.news.back}
          </Link>
        </article>
      </section>
      <FinalCTA />
    </div>
  );
};

export default NewsDetail;
